/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CopilotCsatService
 */

export const shouldSendCsatSurveyRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotCsatService',
  rpcName: 'shouldSendCsatSurvey',
  auth: 'app',
  fingerprint: 'wha7ypeAoFNlPYKaJ9Yoq6VNEWbjYErK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const submitCsatSurveyRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotCsatService',
  rpcName: 'submitCsatSurvey',
  auth: 'app',
  fingerprint: 'OKTwf-L972r719J6M7fkEqVNEWbjYErK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const closeCsatSurveyRpc = {
  serviceName: 'com.hubspot.copilot.rpc.CopilotCsatService',
  rpcName: 'closeCsatSurvey',
  auth: 'app',
  fingerprint: 'fVNYg7wDO6SGTmoFibD5VqVNEWbjYErK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};